import { BrowserRouter as Router } from "react-router-dom";
import React from "react";
import ToastNotificationWrapper from "~/components/ToastNotificationContext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const AppConfigContext = React.createContext({});

const AppContext = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <AppConfigContext.Provider value={{}}>
      <Router>
        <DndProvider backend={HTML5Backend}>
          <ToastNotificationWrapper>{children}</ToastNotificationWrapper>
        </DndProvider>
      </Router>
    </AppConfigContext.Provider>
  );
};

export default AppContext;
